var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKaiserSignupBackgroundGraphic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 575,
    viewBox: "0 0 1440 575",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1167_13770)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1074 538.289C1074 538.289 1109.8 532.221 1118.78 509.411C1127.76 486.601 1143.48 441.768 1171.2 429.408C1198.92 417.048 1231.7 410.531 1252.8 380.305C1279.4 341.427 1336.64 337.719 1363.91 369.855C1387.99 398.219 1381.46 420.234 1417.33 433.278C1427.59 437.009 1436.67 443.903 1441.08 453.891V453.891C1443.01 458.249 1444 462.96 1444 467.724V484.5L1247.75 520.648L1112.5 543.345L1074 538.289Z",
    fill: "#FAEDCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 447.275C1339.44 445.027 1343.71 405.475 1310.6 398.958C1286.02 394.126 1260.99 416.936 1245.95 439.409C1230.91 461.882 1196.68 474.804 1180.96 483.456C1165.25 492.108 1163.57 527.053 1163.57 527.053L1396.69 485.254C1398.15 464.691 1377.16 449.522 1358.3 447.275Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.49 502.67C1222.49 502.67 1222.49 486.265 1233.49 486.714C1233.49 486.714 1227.09 492.332 1228.22 502.445L1222.16 503.681L1222.49 502.67Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.49 502.67C1222.49 502.67 1222.49 486.265 1233.49 486.714C1233.49 486.714 1227.09 492.332 1228.22 502.445L1222.16 503.681L1222.49 502.67Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.16 503.569C1222.16 503.569 1215.53 478.849 1200.72 481.658C1200.72 481.658 1211.94 488.063 1213.85 506.266L1222.16 503.569Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.16 503.569C1222.16 503.569 1215.53 478.849 1200.72 481.658C1200.72 481.658 1211.94 488.063 1213.85 506.266L1222.16 503.569Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.54 506.379C1215.54 506.379 1212.28 498.513 1208.13 494.918C1206.33 493.345 1203.86 490.76 1200.05 489.861L1197.24 494.019C1197.24 494.019 1200.05 495.48 1203.19 500.873C1204.65 503.345 1205.66 508.626 1205.66 508.626L1215.54 506.379Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.54 506.379C1215.54 506.379 1212.5 498.176 1208.13 494.918C1208.13 494.918 1203.86 490.76 1200.05 489.861L1197.24 494.019C1197.24 494.019 1200.05 495.48 1203.19 500.873C1204.65 503.345 1205.66 508.626 1205.66 508.626L1215.54 506.379Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.05 489.748C1200.05 489.748 1195.22 496.715 1194.88 504.018C1194.88 504.018 1191.29 499.411 1192.64 491.321L1200.05 489.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1200.05 489.748C1200.05 489.748 1195.22 496.715 1194.88 504.018C1194.88 504.018 1191.29 499.411 1192.64 491.321L1200.05 489.748Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208.91 510.871C1208.91 510.871 1233.49 505.815 1246.06 490.646C1268.73 463.454 1275.92 439.183 1299.71 438.734C1323.51 438.284 1341.58 484.578 1364.59 486.151L1289.61 498.399L1208.91 510.871Z",
    fill: "#F6C84A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1261.78 498.287C1261.78 498.287 1271.76 471.32 1288.71 468.848C1306.45 466.151 1307.57 488.174 1323.51 490.421L1261.78 498.287Z",
    fill: "#EDB418"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 343.9H1223.84V390.307H1358.3V343.9Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.49 333.787V505.929",
    stroke: "#5E6574",
    strokeWidth: 2.10781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1222.49 333.787C1225.47 333.787 1227.88 331.372 1227.88 328.393C1227.88 325.415 1225.47 323 1222.49 323C1219.52 323 1217.11 325.415 1217.11 328.393C1217.11 331.372 1219.52 333.787 1222.49 333.787Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.35 481.748C1363.35 481.748 1366.16 473.096 1370.87 473.096C1370.87 473.096 1368.85 478.939 1370.53 481.186L1363.35 481.748Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 335.787V483.77",
    stroke: "#5E6574",
    strokeWidth: 2.10781,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.74 480.849C1357.74 480.849 1361.22 464.893 1371.88 467.59C1371.88 467.59 1364.47 471.748 1363.35 481.86L1357.18 481.748L1357.74 480.849Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.74 480.849C1357.74 480.849 1361.22 464.893 1371.88 467.59C1371.88 467.59 1364.47 471.748 1363.35 481.86L1357.18 481.748L1357.74 480.849Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.18 481.636C1357.18 481.636 1355.94 456.129 1340.9 455.68C1340.9 455.68 1350.55 464.332 1348.42 482.535L1357.18 481.636Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1357.18 481.636C1357.18 481.636 1355.94 456.129 1340.9 455.68C1340.9 455.68 1350.55 464.332 1348.42 482.535L1357.18 481.636Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 335.787C1361.27 335.787 1363.69 333.372 1363.69 330.393C1363.69 327.415 1361.27 325 1358.3 325C1355.32 325 1352.91 327.415 1352.91 330.393C1352.91 333.372 1355.32 335.787 1358.3 335.787Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1363.35 481.748C1363.35 481.748 1366.16 473.096 1370.87 473.096C1370.87 473.096 1368.85 478.939 1370.53 481.186L1363.35 481.748Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.99 357.609C1127.99 357.609 1124.62 346.373 1115.08 350.306C1115.08 350.306 1115.08 340.755 1105.54 346.935",
    stroke: "#5E6574",
    strokeWidth: 1.40521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1160.09 349.181C1160.09 349.181 1160.42 340.979 1154.25 343.338C1154.25 343.338 1152.9 336.147 1146.96 339.855",
    stroke: "#5E6574",
    strokeWidth: 1.40521,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.3 343.9H1222.49V390.307H1358.3V343.9Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1245.95 344.91H1223.84V367.271H1245.95V344.91Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.06 367.271H1245.95V389.632H1268.06V367.271Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1290.28 344.91H1268.17V367.271H1290.28V344.91Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1312.39 367.271H1290.28V389.632H1312.39V367.271Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.51 344.91H1312.39V367.271H1334.51V344.91Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1356.61 367.271H1334.5V389.632H1356.61V367.271Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 554C283 554 425.758 590.632 622.446 566.94C848.84 539.421 1143.01 450.12 1448.71 488.391V701.256H283V554Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.577 564.934C283.577 564.934 424.893 603.753 622.447 583.159C849.129 559.467 1145.6 475.086 1449 517.185V488.39C1143.3 450.118 849.129 539.42 622.736 566.757C426.047 590.449 283.289 553.817 283.289 553.817V575.14L283.577 564.934Z",
    fill: "#E5F7F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1183.38 484.381C1183.38 484.381 1063.98 496.045 1004.57 504.428C1004.57 504.428 966.216 517.732 897.865 555.093C829.803 592.453 724.537 656.422 612.35 651.319C612.35 651.319 678.105 664.076 736.361 675.011C794.907 685.946 855.47 689.227 855.47 689.227C855.47 689.227 902.48 686.675 931.32 666.446C959.871 646.216 992.46 618.332 1025.63 583.705C1058.79 549.079 1132.05 493.858 1183.38 484.381Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M934.494 535.774C993.328 526.844 1053.89 518.461 1116.19 512.994C1139.55 498.961 1163.19 488.208 1183.38 484.381C1183.38 484.381 1063.99 496.045 1004.58 504.428C1004.58 504.428 979.773 512.994 934.494 535.774Z",
    fill: "#FAEDCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283 554C283 554 425.758 590.632 622.446 566.94C848.84 539.421 1143.01 450.12 1448.71 488.391",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1014.96 501.695C1014.96 501.695 981.504 506.798 898.156 554.911C816.539 601.931 717.041 654.418 612.641 651.138",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.52 482.012C1197.52 482.012 1150.8 484.199 1082.73 534.681C995.925 599.197 949.492 692.325 845.092 689.227",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.5723 408.415L71.2407 403.054L84.8663 416.813V211.781H123.796V371.965L137.515 361.065L140.481 364.46L123.796 383.221V488.819H84.8663V426.461L69.5723 408.415Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.328 486.828V204.072H123.675V371.484L137.371 360.181L140.333 363.701L123.675 383.157V489.329L114.328 486.828Z",
    fill: "#FAEDCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8066 427.998V492.665H123.675V383.064",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.991 371.326V215.904H84.4141V417.911",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.092 208.149C110.441 207.779 115.994 199.719 122.564 204.073C129.135 208.427 131.449 241.965 159.396 260.309C187.344 278.653 207.426 289.771 199.282 304.316C191.139 318.769 146.903 288.288 139.87 290.604C132.837 292.921 143.942 308.948 126.636 310.153C109.331 311.357 96.3748 292.365 84.2517 290.604C76.9408 289.585 55.0082 304.872 36.4996 300.147C26.0423 297.46 26.1348 287.64 27.8931 284.582C32.8905 275.596 47.3271 275.133 57.3218 263.181C71.7584 245.856 81.9381 210.188 89.3416 203.888C94.4314 199.533 99.7064 208.705 106.092 208.149Z",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.397 260.31C187.345 278.654 207.612 290.605 200.023 302.835C194.471 311.729 174.666 304.688 159.212 297.554C165.875 288.011 152.271 277.264 137.279 263.09C125.249 251.694 126.452 229.644 128.58 216.025C133.392 228.625 140.518 247.988 159.397 260.31Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.092 208.149C110.441 207.779 115.994 199.719 122.564 204.073C129.135 208.427 131.449 241.965 159.396 260.309C187.344 278.653 210.017 291.623 199.282 304.316C189.01 316.545 146.903 288.288 139.87 290.604C132.837 292.921 143.942 308.948 126.636 310.153C109.331 311.357 96.3748 292.365 84.2517 290.604C76.9408 289.585 55.0082 304.872 36.4996 300.147C26.0423 297.46 26.1348 287.64 27.8931 284.582C32.8905 275.596 47.3271 275.133 57.3218 263.181C71.7584 245.856 81.9381 210.188 89.3416 203.888C94.4314 199.533 99.7064 208.705 106.092 208.149Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.359 373.43L137.369 360.182L140.331 363.702L122.1 385.011",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.775 317.75V377.692",
    stroke: "#F6C84A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.775 391.219V400.483",
    stroke: "#F6C84A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5215 357.311V390.015",
    stroke: "#F6C84A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9688 308.484V341.188",
    stroke: "#F6C84A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9688 404.189V424.016",
    stroke: "#F6C84A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.779 416.604V447.455",
    stroke: "#F6C84A",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.5256 422.903L84.8985 418.085L71.2947 403.91L69.6289 409.469L87.4897 431.241",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69652 245.195H-3.52734V472.058H7.69652V245.195Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69684 245.195H3.65625V474.08H7.69684V245.195Z",
    fill: "#FAEDCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69727 252.949V479.138",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.63913 272.949C-2.74122 271.151 2.98295 270.477 6.0134 272.162C9.15608 273.96 8.37041 283.624 19.931 288.23C31.4916 292.837 38.5626 294.41 39.2361 299.242C40.0217 304.411 30.5937 312.389 8.25817 298.905C8.25817 298.905 3.76862 312.726 -5.09824 311.265C-11.3836 310.254 -12.506 300.366 -12.506 300.366C-12.506 300.366 -37.423 319.468 -42.6982 311.827C-46.851 305.759 -34.7293 300.59 -27.9949 297.894C-14.5263 292.5 -7.79196 281.376 -3.63913 272.949Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2367 299.355C38.451 294.523 31.4922 292.95 19.9316 288.343C8.37104 283.736 9.04447 273.96 6.01403 272.275C4.7794 271.601 3.20806 271.264 1.63672 271.264C1.97343 276.32 3.54478 287.332 11.626 290.141C21.503 293.512 30.2576 299.692 25.2069 306.096C35.4206 307.894 39.7979 302.95 39.2367 299.355Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.63913 272.949C-2.74122 271.151 2.98295 270.477 6.0134 272.162C9.15608 273.96 8.37041 283.624 19.931 288.23C31.4916 292.837 38.5626 294.41 39.2361 299.242C40.0217 304.411 30.5937 312.389 8.25817 298.905C8.25817 298.905 3.76862 312.726 -5.09824 311.265C-11.3836 310.254 -12.506 300.366 -12.506 300.366C-12.506 300.366 -37.423 319.468 -42.6982 311.827C-46.851 305.759 -34.7293 300.59 -27.9949 297.894C-14.5263 292.5 -7.79196 281.376 -3.63913 272.949Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.87022 209.801C-3.41515 209.801 -2.18052 223.846 -15.8736 232.723C-23.9548 237.892 -27.5465 241.487 -28.8933 245.308C-30.6892 250.252 -26.3118 252.387 -23.8426 252.724C-19.5775 253.173 -13.8534 251.488 -9.47604 245.083C-9.47604 245.083 -5.8844 254.971 2.87022 255.083C11.9616 255.083 14.3186 244.296 14.3186 244.296C14.3186 244.296 22.2875 249.578 28.3484 247.892C32.7257 246.656 32.7257 241.824 31.6033 239.69C29.0218 234.633 20.3795 230.251 13.5329 224.633C9.38007 221.037 6.34962 209.801 2.87022 209.801Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5319 224.745C9.37908 221.15 6.34863 209.801 2.86923 209.801C2.30804 209.801 1.74685 209.913 1.29789 210.138C-1.39584 215.868 1.07341 226.206 5.11401 230.139C6.68535 231.599 8.59341 232.948 9.60356 234.746C10.7259 236.656 10.7259 239.24 9.60356 241.15C7.47102 245.083 1.97132 246.094 -0.610167 249.802C-1.39584 251.038 -1.84479 252.387 -1.95703 253.847C-0.610166 254.522 0.961175 254.971 2.757 254.971C11.8483 254.971 14.2053 244.184 14.2053 244.184C14.2053 244.184 22.1743 249.465 28.2352 247.78C32.6125 246.544 32.6125 241.712 31.4901 239.577C29.0209 234.746 20.3785 230.251 13.5319 224.745Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.75749 209.801C-3.52788 209.801 -2.18102 223.846 -15.8741 232.835C-23.8431 238.004 -27.547 241.6 -28.8938 245.42C-30.6896 250.477 -26.3123 252.499 -23.7308 252.836C-19.578 253.398 -13.7416 251.713 -9.36429 245.195C-9.36429 245.195 -5.77265 255.083 2.98196 255.083C12.0733 255.083 14.4303 244.296 14.4303 244.296C14.4303 244.296 22.3993 249.578 28.4601 247.892C32.8375 246.656 32.8375 241.824 31.7151 239.69C29.1336 234.633 20.1545 230.588 13.5324 224.745C7.69599 219.576 7.69599 209.801 2.75749 209.801Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07505 329.805C9.044 329.805 8.93176 339.131 15.4416 346.21C22.8494 354.188 33.8488 354.3 32.3897 360.143C30.8183 366.435 15.7783 366.435 9.38071 354.412C9.38071 354.412 7.80937 365.312 -0.608533 364.3C-7.34286 363.514 -8.9142 354.525 -8.9142 354.525C-8.9142 354.525 -16.9954 366.885 -29.7906 362.39C-31.2497 361.828 -32.4843 361.267 -33.3822 360.705C-38.6575 357.446 -37.6473 351.828 -34.1679 350.03C-32.0354 348.794 -28.2193 349.244 -25.75 349.244C-19.0157 349.244 -13.4037 347.895 -8.01629 340.929C-4.53689 336.322 -3.4145 329.805 1.07505 329.805Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4415 346.211C9.82951 340.031 9.04384 332.278 3.88086 330.256C4.55429 335.874 7.13578 348.346 18.1352 353.515C25.9919 357.223 23.9716 361.044 20.6044 363.74C26.2164 365.313 31.4916 363.74 32.3895 360.257C33.8486 354.302 22.8492 354.189 15.4415 346.211Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.07505 329.805C9.044 329.805 8.93176 339.131 15.4416 346.21C22.8494 354.188 33.8488 354.3 32.3897 360.143C30.8183 366.435 15.7783 366.435 9.38071 354.412C9.38071 354.412 7.80937 365.312 -0.608533 364.3C-7.34286 363.514 -8.9142 354.525 -8.9142 354.525C-8.9142 354.525 -16.9954 366.885 -29.7906 362.39C-31.2497 361.828 -32.4843 361.267 -33.3822 360.705C-38.6575 357.446 -37.6473 351.828 -34.1679 350.03C-32.0354 348.794 -28.2193 349.244 -25.75 349.244C-19.0157 349.244 -13.4037 347.895 -8.01629 340.929C-4.53689 336.322 -3.4145 329.805 1.07505 329.805Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.739 338.795H144.852V475.766H155.739V338.795Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.628 338.795H151.699V475.766H155.628V338.795Z",
    fill: "#FAEDCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.852 346.322V470.821",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.627 346.322V477.451",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.627 365.65C145.525 363.852 151.025 363.178 153.943 364.864C156.974 366.549 156.188 375.875 167.412 380.37C178.636 384.864 185.37 386.325 186.156 391.044C186.941 395.988 177.85 403.741 156.188 390.707C156.188 390.707 151.923 404.078 143.281 402.73C137.22 401.719 136.21 392.28 136.21 392.28C136.21 392.28 112.078 410.708 107.027 403.292C102.987 397.449 114.66 392.505 121.282 389.808C134.189 384.527 140.699 373.853 144.627 365.65Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.155 391.155C185.482 386.436 178.635 384.975 167.411 380.48C156.188 375.986 156.973 366.66 153.943 364.974C152.708 364.3 151.249 363.963 149.678 363.963C150.014 368.907 151.586 379.469 159.33 382.166C168.871 385.424 177.401 391.38 172.462 397.56C182.451 399.358 186.717 394.526 186.155 391.155Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.627 365.65C145.525 363.852 151.025 363.178 153.943 364.864C156.974 366.549 156.188 375.875 167.412 380.37C178.636 384.864 185.37 386.325 186.156 391.044C186.941 395.988 177.85 403.741 156.188 390.707C156.188 390.707 151.923 404.078 143.281 402.73C137.22 401.719 136.21 392.28 136.21 392.28C136.21 392.28 112.078 410.708 107.027 403.292C102.987 397.449 114.66 392.505 121.282 389.808C134.189 384.527 140.699 373.853 144.627 365.65Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.912 304.635C144.851 304.635 146.086 318.231 132.842 326.883C125.097 331.827 121.506 335.31 120.271 339.018C118.475 343.85 122.74 345.872 125.21 346.097C129.25 346.546 134.862 344.973 139.127 338.793C139.127 338.793 142.607 348.344 151.024 348.457C159.891 348.457 162.136 338.119 162.136 338.119C162.136 338.119 169.881 343.176 175.605 341.602C179.87 340.479 179.87 335.76 178.747 333.625C176.278 328.793 167.86 324.523 161.238 319.13C157.198 315.534 154.279 304.635 150.912 304.635Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.352 319.018C157.311 315.535 154.393 304.636 151.026 304.523C150.464 304.523 150.015 304.636 149.567 304.861C146.873 310.366 149.342 320.479 153.27 324.187C154.73 325.648 156.638 326.884 157.648 328.682C158.658 330.592 158.77 332.951 157.648 334.862C155.627 338.682 150.24 339.693 147.771 343.289C146.985 344.413 146.648 345.761 146.424 347.222C147.771 347.896 149.23 348.345 151.026 348.345C159.892 348.345 162.137 338.008 162.137 338.008C162.137 338.008 169.882 343.064 175.606 341.491C179.871 340.368 179.871 335.648 178.749 333.513C176.279 328.682 167.861 324.412 161.352 319.018Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.912 304.635C144.851 304.635 146.086 318.231 132.842 326.883C125.097 331.827 121.618 335.422 120.271 339.018C118.475 343.85 122.74 345.872 125.21 346.097C129.25 346.546 134.862 344.973 139.127 338.793C139.127 338.793 142.607 348.344 151.024 348.344C159.891 348.344 162.136 338.007 162.136 338.007C162.136 338.007 169.881 343.063 175.605 341.49C179.87 340.366 179.87 335.647 178.747 333.512C176.278 328.681 167.636 324.636 161.238 319.017C155.626 314.073 155.626 304.635 150.912 304.635Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.228 420.596C156.973 420.596 156.861 429.585 163.146 436.439C170.217 444.192 180.88 444.304 179.533 449.923C178.074 455.99 163.483 455.99 157.31 444.417C157.31 444.417 155.738 454.979 147.657 453.968C141.147 453.181 139.688 444.529 139.688 444.529C139.688 444.529 131.831 456.44 119.597 452.058C118.138 451.608 117.016 451.046 116.118 450.372C111.067 447.226 111.965 441.832 115.332 440.035C117.465 438.911 121.057 439.248 123.526 439.248C130.036 439.248 135.423 438.012 140.698 431.27C143.841 426.888 144.963 420.596 149.228 420.596Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.148 436.439C157.648 430.483 156.975 422.955 151.924 421.045C152.485 426.438 155.067 438.574 165.617 443.518C173.137 447.001 171.341 450.709 168.086 453.406C173.474 454.866 178.637 453.406 179.422 450.035C180.881 444.304 170.219 444.192 163.148 436.439Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.228 420.596C156.973 420.596 156.861 429.585 163.146 436.439C170.217 444.192 180.88 444.304 179.533 449.923C178.074 455.99 163.483 455.99 157.31 444.417C157.31 444.417 155.738 454.979 147.657 453.968C141.147 453.181 139.688 444.529 139.688 444.529C139.688 444.529 131.831 456.44 119.597 452.058C118.138 451.608 117.016 451.046 116.118 450.372C111.067 447.226 111.965 441.832 115.332 440.035C117.465 438.911 121.057 439.248 123.526 439.248C130.036 439.248 135.423 438.012 140.698 431.27C143.841 426.888 144.963 420.596 149.228 420.596Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.939 148C128.939 148 128.663 170.053 144.083 186.869C161.431 205.89 187.59 206.165 184.285 219.948C180.706 234.834 144.909 234.834 129.765 206.441C129.765 206.441 125.91 232.353 106.084 229.872C90.1132 227.943 86.5335 206.717 86.5335 206.717C86.5335 206.717 67.2585 235.937 37.2446 225.186C33.665 224.083 30.9114 222.705 28.7085 221.051C16.3174 213.333 18.5203 200.101 26.781 195.69C32.0128 192.933 40.8242 193.76 46.8821 193.76C62.8528 193.76 76.07 190.728 89.0118 174.188C96.7218 163.437 99.4753 148 109.939 148Z",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.083 186.868C130.59 172.257 128.938 153.788 116.547 149.102C117.924 162.333 124.257 192.105 150.14 204.234C168.589 212.78 164.184 221.877 156.198 228.493C169.415 232.076 182.082 228.493 184.009 220.223C187.589 206.164 161.43 205.888 144.083 186.868Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.939 148C128.939 148 128.663 170.053 144.083 186.869C161.431 205.89 187.59 206.165 184.285 219.948C180.706 234.834 144.909 234.834 129.765 206.441C129.765 206.441 125.91 232.353 106.084 229.872C90.1132 227.943 86.5335 206.717 86.5335 206.717C86.5335 206.717 67.2585 235.937 37.2446 225.186C33.665 224.083 30.9114 222.705 28.7085 221.051C16.3174 213.333 18.5203 200.101 26.781 195.69C32.0128 192.933 40.8242 193.76 46.8821 193.76C62.8528 193.76 76.07 190.728 89.0118 174.188C96.7218 163.437 99.4753 148 109.939 148Z",
    stroke: "#5E6574",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.5417 129.758H50.832V465.793H77.5417V129.758Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2664 129.758H67.6289V465.793H77.2664V129.758Z",
    fill: "#FAEDCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.832 148.227V453.663",
    stroke: "#5E6574",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2656 148.227V469.927",
    stroke: "#5E6574",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2815 195.641C52.4844 191.23 65.9769 189.576 73.1362 193.711C80.5708 197.846 78.6433 220.726 106.179 231.753C133.715 242.779 150.236 246.363 152.164 257.941C154.091 270.07 131.787 289.091 78.6433 257.114C78.6433 257.114 68.1797 289.918 46.9772 286.61C32.1079 284.129 29.6297 260.973 29.6297 260.973C29.6297 260.973 -29.5721 306.182 -41.9632 287.988C-51.8761 273.654 -23.2389 261.525 -6.99285 254.909C24.6732 241.953 40.644 215.764 50.2815 195.641Z",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.163 258.219C150.511 246.641 133.714 243.057 106.178 232.03C78.6426 221.004 80.5701 198.124 73.1355 193.989C70.1065 192.335 66.5269 191.508 62.6719 191.508C63.4979 203.637 67.3529 229.549 86.3526 236.165C109.758 244.16 130.685 258.77 118.569 273.931C143.076 278.342 153.54 266.489 152.163 258.219Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2815 195.641C52.4844 191.23 65.9769 189.576 73.1362 193.711C80.5708 197.846 78.6433 220.726 106.179 231.753C133.715 242.779 150.236 246.363 152.164 257.941C154.091 270.07 131.787 289.091 78.6433 257.114C78.6433 257.114 68.1797 289.918 46.9772 286.61C32.1079 284.129 29.6297 260.973 29.6297 260.973C29.6297 260.973 -29.5721 306.182 -41.9632 287.988C-51.8761 273.654 -23.2389 261.525 -6.99285 254.909C24.6732 241.953 40.644 215.764 50.2815 195.641Z",
    stroke: "#5E6574",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5717 330.441C80.5714 330.441 80.2961 352.495 95.7161 369.31C113.064 388.331 139.223 388.607 135.918 402.39C132.339 417.276 96.5422 417.276 81.3975 388.882C81.3975 388.882 77.5425 414.795 57.7167 412.314C41.746 410.384 38.1664 389.158 38.1664 389.158C38.1664 389.158 18.8914 418.378 -11.1226 407.627C-14.7022 406.525 -17.4558 405.147 -19.6587 403.493C-32.0497 395.774 -29.8469 382.542 -21.5862 378.131C-16.3544 375.375 -7.54294 376.202 -1.48508 376.202C14.4856 376.202 27.7028 373.169 40.6446 356.63C48.3546 345.879 51.1082 330.441 61.5717 330.441Z",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7154 369.309C82.2229 354.699 80.5708 336.229 68.1797 331.543C69.5565 344.775 75.8897 374.547 101.773 386.676C120.222 395.221 115.816 404.318 107.831 410.934C121.048 414.518 133.715 410.934 135.642 402.664C139.222 388.605 113.063 388.33 95.7154 369.309Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5717 330.441C80.5714 330.441 80.2961 352.495 95.7161 369.31C113.064 388.331 139.223 388.607 135.918 402.39C132.339 417.276 96.5422 417.276 81.3975 388.882C81.3975 388.882 77.5425 414.795 57.7167 412.314C41.746 410.384 38.1664 389.158 38.1664 389.158C38.1664 389.158 18.8914 418.378 -11.1226 407.627C-14.7022 406.525 -17.4558 405.147 -19.6587 403.493C-32.0497 395.774 -29.8469 382.542 -21.5862 378.131C-16.3544 375.375 -7.54294 376.202 -1.48508 376.202C14.4856 376.202 27.7028 373.169 40.6446 356.63C48.3546 345.879 51.1082 330.441 61.5717 330.441Z",
    stroke: "#5E6574",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1519 65.9824C90.2674 65.9824 89.9614 90.4915 107.099 109.18C126.378 130.319 155.45 130.625 151.778 145.943C147.8 162.487 108.017 162.487 91.1855 130.931C91.1855 130.931 86.9012 159.729 64.8677 156.972C47.1184 154.828 43.1401 131.238 43.1401 131.238C43.1401 131.238 21.7186 163.712 -11.6377 151.764C-15.616 150.539 -18.6762 149.007 -21.1244 147.169C-34.8954 138.59 -32.4472 123.885 -23.2666 118.983C-17.4522 115.92 -7.65946 116.839 -0.926989 116.839C16.8223 116.839 31.5113 113.469 45.8943 95.0869C54.4629 83.1387 57.5231 65.9824 69.1519 65.9824Z",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.098 109.179C92.1032 92.9415 90.2671 72.4152 76.4961 67.207C78.0262 81.9124 85.0647 115 113.831 128.48C134.334 137.977 129.438 148.087 120.563 155.439C135.252 159.422 149.329 155.439 151.471 146.249C155.45 130.624 126.378 130.318 107.098 109.179Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1519 65.9824C90.2674 65.9824 89.9614 90.4915 107.099 109.18C126.378 130.319 155.45 130.625 151.778 145.943C147.8 162.487 108.017 162.487 91.1855 130.931C91.1855 130.931 86.9012 159.729 64.8677 156.972C47.1184 154.828 43.1401 131.238 43.1401 131.238C43.1401 131.238 21.7186 163.712 -11.6377 151.764C-15.616 150.539 -18.6762 149.007 -21.1244 147.169C-34.8954 138.59 -32.4472 123.885 -23.2666 118.983C-17.4522 115.92 -7.65946 116.839 -0.926989 116.839C16.8223 116.839 31.5113 113.469 45.8943 95.0869C54.4629 83.1387 57.5231 65.9824 69.1519 65.9824Z",
    stroke: "#5E6574",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6943 0.275391C48.825 0.275391 51.854 33.6308 19.3618 54.857C0.362131 66.9862 -8.44932 75.5318 -11.4782 84.6287C-15.884 96.4823 -5.42038 101.444 0.63748 101.996C10.5503 103.098 24.3182 99.2389 34.7818 84.0774C34.7818 84.0774 43.3179 107.509 63.9697 107.785C85.7229 107.785 91.23 82.4234 91.23 82.4234C91.23 82.4234 110.23 94.8283 124.273 90.969C134.736 88.2123 134.737 76.6344 131.983 71.3968C125.925 59.5432 105.273 49.068 89.0272 35.8361C79.1143 27.0148 71.955 0.275391 63.6943 0.275391Z",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3022 35.5607C79.3894 27.0151 72.2301 0.275664 63.9694 0C62.5926 0 61.4911 0.275673 60.3897 0.827001C53.7811 14.3346 59.839 39.1443 69.4765 48.2412C73.0562 51.8249 77.7372 54.8572 80.2154 59.2678C82.6936 63.9541 82.969 69.7431 80.2154 74.4294C75.259 83.8019 62.0419 86.2829 55.984 95.1042C54.0565 97.8608 53.2304 101.169 52.6797 104.752C55.984 106.406 59.5636 107.509 63.9694 107.509C85.7226 107.509 91.2297 82.148 91.2297 82.148C91.2297 82.148 110.229 94.5529 124.273 90.6936C134.736 87.9369 134.736 76.359 131.983 71.1214C125.925 59.2678 105.273 48.7926 89.3022 35.5607Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6943 0.275391C48.825 0.275391 51.854 33.6308 19.3618 54.8569C0.362131 66.9862 -8.17396 75.8074 -11.4782 84.6287C-15.884 96.4823 -5.42038 101.444 0.63748 101.996C10.5503 103.098 24.3182 99.2389 34.7818 84.0773C34.7818 84.0773 43.3179 107.509 63.9697 107.509C85.7229 107.509 91.23 82.1477 91.23 82.1477C91.23 82.1477 110.23 94.5526 124.273 90.6933C134.736 87.9367 134.737 76.3588 131.983 71.1211C125.925 59.2676 104.723 49.3437 89.0272 35.5604C75.2593 23.4312 75.2593 0.275391 63.6943 0.275391Z",
    stroke: "#5E6574",
    strokeWidth: 1.1,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.891 635.211C557.891 635.211 499.527 631.84 393.237 577.793C260.234 510.15 163.147 452.17 -32.9336 448.35V639.368H676.415L557.891 635.211Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7272 686.562C-17.5564 520.263 80.0913 479.812 80.0913 479.812C80.0913 479.812 154.169 537.118 94.6824 695.551",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7272 686.562C-17.5564 520.263 80.0913 479.812 80.0913 479.812C80.0913 479.812 154.169 537.118 94.6824 695.551",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3364 500.038C82.3364 500.038 6.12627 531.612 15.4421 653.752C-4.42417 514.87 80.0916 479.812 80.0916 479.812C80.0916 479.812 113.763 505.881 117.467 571.277C108.937 520.601 82.3364 500.038 82.3364 500.038Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7272 686.562C-17.5564 520.263 80.0913 479.812 80.0913 479.812C80.0913 479.812 154.169 537.118 94.6824 695.551",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0919 479.812C80.0919 479.812 44.7367 549.478 58.7666 688.809",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.3583 539.591L38.9004 517.455",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.784 514.195L64.4902 533.297",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.464 676.481C183.281 638.165 204.382 605.355 206.402 579.062C208.422 552.657 191.923 549.51 182.383 556.589C171.833 564.455 164.874 588.163 164.874 588.163C164.874 588.163 145.681 640.076 155.895 680.077L190.464 676.481Z",
    fill: "#BDADFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.199 678.053C177.893 670.413 181.821 657.266 180.587 649.176C176.995 626.703 180.474 614.455 185.862 606.815C192.933 596.814 199.331 585.69 192.035 574.341C186.535 565.914 186.311 558.835 187.209 554.116C196.637 550.97 208.197 556.7 206.514 579.061C204.494 605.466 183.393 638.164 190.576 676.48L175.199 678.053Z",
    fill: "#DED6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.875 588.162C164.875 588.162 171.834 564.566 182.384 556.588C191.925 549.397 208.424 552.655 206.403 579.061C204.383 605.466 183.282 638.164 190.465 676.48",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.232 665.244C145.232 665.244 146.242 583.781 119.417 569.623C106.847 562.993 96.5206 571.083 95.286 583.781C94.7248 589.623 94.6126 594.905 98.7654 604.118C105.724 619.512 120.764 624.007 121.101 661.199L145.232 665.244Z",
    fill: "#BDADFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.762 669.964C164.762 669.964 173.292 631.086 164.088 584.342C154.885 537.599 136.927 525.239 124.58 527.262C113.132 529.172 103.367 543.217 116.275 568.05L137.039 669.964H164.762Z",
    fill: "#BDADFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.888 580.972C104.154 578.724 103.256 573.331 103.817 569.061C108.082 566.701 113.47 566.477 119.418 569.623C146.243 583.781 145.233 665.245 145.233 665.245L141.978 664.683C130.53 663.11 131.203 617.49 132.101 604.793C132.999 590.185 122.786 584.904 110.888 580.972Z",
    fill: "#DED6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.58 527.262C136.926 525.239 154.884 537.599 164.088 584.342C173.291 631.086 164.761 669.964 164.761 669.964H158.812C153.088 648.839 155.782 622.995 156.792 610.411C158.925 583.78 152.19 562.656 134.569 551.644C125.028 545.689 123.345 535.576 123.794 527.486C124.018 527.374 124.243 527.374 124.58 527.262Z",
    fill: "#DED6FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.762 669.964C164.762 669.964 173.292 631.086 164.088 584.342C154.885 537.599 136.927 525.239 124.58 527.262C113.132 529.172 103.367 543.217 116.275 568.05",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.232 665.244C145.232 665.244 146.242 583.781 119.417 569.623C106.847 562.993 96.5206 571.083 95.286 583.781C94.7248 589.623 94.6126 594.905 98.7654 604.118C105.724 619.512 120.764 624.007 121.101 661.199L145.232 665.244Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.681 551.724C101.641 557.455 83.6823 561.387 83.6823 561.387C83.6823 561.387 80.9886 543.185 85.0292 537.454C88.9575 531.723 96.8142 530.375 102.426 534.308C108.038 538.24 109.609 545.994 105.681 551.724Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.681 551.724C101.641 557.455 83.6823 561.387 83.6823 561.387C83.6823 561.387 80.9886 543.185 85.0292 537.454C88.9575 531.723 96.8142 530.375 102.426 534.308C108.038 538.24 109.609 545.994 105.681 551.724Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1949 573.186C63.5926 575.883 71.1126 592.737 71.1126 592.737C71.1126 592.737 53.8278 599.03 47.4302 596.333C41.0326 593.636 38.1144 586.22 40.8081 579.816C43.3896 573.411 50.7973 570.489 57.1949 573.186Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1949 573.186C63.5926 575.883 71.1126 592.737 71.1126 592.737C71.1126 592.737 53.8278 599.03 47.4302 596.333C41.0326 593.636 38.1144 586.22 40.8081 579.816C43.3896 573.411 50.7973 570.489 57.1949 573.186Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2324 595.659C87.2736 595.434 74.2539 582.4 74.2539 582.4C74.2539 582.4 88.1715 570.265 95.1303 570.489C102.089 570.714 107.477 576.557 107.252 583.411C106.915 590.49 101.191 595.884 94.2324 595.659Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.2324 595.659C87.2736 595.434 74.2539 582.4 74.2539 582.4C74.2539 582.4 88.1715 570.265 95.1303 570.489C102.089 570.714 107.477 576.557 107.252 583.411C106.915 590.49 101.191 595.884 94.2324 595.659Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9383 555.882C78.7442 560.376 76.1627 574.422 76.1627 574.422C76.1627 574.422 62.4696 570.826 59.5514 566.219C56.7454 561.725 58.0923 555.769 62.5818 552.848C67.1836 550.039 73.1323 551.387 75.9383 555.882Z",
    fill: "#FFA584"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.9383 555.882C78.7442 560.376 76.1627 574.422 76.1627 574.422C76.1627 574.422 62.4696 570.826 59.5514 566.219C56.7454 561.725 58.0923 555.769 62.5818 552.848C67.1836 550.039 73.1323 551.387 75.9383 555.882Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.6815 561.387C83.6815 561.387 67.6314 578.129 66.8457 643.188",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.464 639.368H655.202L655.089 638.582L580.787 634.761C580.787 634.761 499.414 631.84 393.124 577.68C291.66 525.993 210.848 479.924 90.8653 459.474C54.9489 453.631 14.3185 449.698 -32.934 448.35L-42.2498 453.968C-85.3495 492.396 90.7531 454.979 204.339 496.778C299.629 531.948 309.619 546.668 390.655 587.793C448.795 617.233 487.741 632.514 526.464 639.368Z",
    fill: "#B2E9DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.348 635.885C603.348 635.885 515.801 637.907 406.256 583.973C272.468 518.128 174.259 451.945 -32.9336 448.35V639.368L603.348 635.885Z",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.2793 623.75C-77.7175 447.676 28.6848 423.967 28.6848 423.967C28.6848 423.967 93.7833 495.43 5.2269 645.885",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.2793 623.75C-77.7175 447.676 28.6848 423.967 28.6848 423.967C28.6848 423.967 93.7833 495.43 5.2269 645.885",
    stroke: "#5E6574",
    strokeWidth: 1.1718,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.2668 432.956C9.2668 432.956 8.03218 433.181 5.89964 433.967C19.0316 426.214 28.6841 423.967 28.6841 423.967C28.6841 423.967 93.7826 495.43 5.22621 645.885L-7.00781 642.177C70.7736 500.374 9.2668 432.956 9.2668 432.956Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-67.2793 623.75C-77.7175 447.676 28.6848 423.967 28.6848 423.967C28.6848 423.967 93.7833 495.43 5.2269 645.885",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7965 423.967C28.7965 423.967 -19.4661 488.464 -29.9043 632.626",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0635173 481.61L-19.8027 454.867",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8379 451.945L8.93164 461.946",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6922 502.734L-11.7227 521.499",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2861 556.219L-23.9551 578.804",
    stroke: "#5E6574",
    strokeWidth: 1.13541,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.588 562.47C292.636 554.925 273.056 543.031 246.856 535.904C220.656 528.777 197.756 529.116 195.708 536.662C193.66 544.207 213.24 556.102 239.44 563.228C265.64 570.355 288.54 570.016 290.588 562.47Z",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.179 457.252C315.179 457.252 313.451 471.985 298.873 477.933C291.273 480.977 283.328 479.732 271.029 477.172",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.048 489.622C225.499 514.177 240.63 538.109 257.764 537.072C274.968 536.104 287.681 510.58 286.299 486.026C284.917 461.471 264.052 456.698 253.412 457.321C241.114 458.013 222.666 465.068 224.048 489.622Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M273.24 462.232L268.127 459.673C267.436 460.019 266.883 459.673 266.331 458.912C261.632 457.39 257.003 457.045 253.48 457.252C247.952 457.598 241.941 459.05 236.276 462.924L234.756 464.031C256.105 471.432 273.24 462.232 273.24 462.232Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.048 489.622C225.499 514.177 240.63 538.109 257.764 537.072C274.968 536.104 287.681 510.58 286.299 486.026C284.917 461.471 264.052 456.698 253.412 457.321C241.114 458.013 222.666 465.068 224.048 489.622Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.556 438.071C297.126 422.834 281.445 408.731 260.531 406.571C239.618 404.412 221.391 415.013 219.821 430.25C218.251 445.488 233.932 459.591 254.846 461.75C275.76 463.91 293.986 453.308 295.556 438.071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.556 438.071C297.126 422.834 281.445 408.731 260.531 406.571C239.618 404.412 221.391 415.013 219.821 430.25C218.251 445.488 233.932 459.591 254.846 461.75C275.76 463.91 293.986 453.308 295.556 438.071Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.818 505.947C276.764 505.255 282.567 498.408 281.876 490.661C281.185 482.914 274.207 477.242 266.331 477.934C258.385 478.626 252.582 485.473 253.273 493.22C253.964 500.967 260.942 506.639 268.818 505.947Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.403 500.966C273.516 500.482 277.247 496.124 276.832 491.144C276.418 486.164 271.927 482.498 266.814 482.982C261.701 483.467 257.97 487.824 258.385 492.804C258.8 497.784 263.29 501.45 268.403 500.966Z",
    fill: "#596DAB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.159 486.857L263.014 495.573L272.825 494.673L267.159 486.857Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.282 457.77C323.011 454.724 320.864 451.598 317.487 450.789C314.11 449.98 310.782 451.793 310.053 454.84C309.325 457.886 311.472 461.012 314.849 461.821C318.226 462.63 321.554 460.817 322.282 457.77Z",
    fill: "#4BD1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.282 457.77C323.011 454.724 320.864 451.598 317.487 450.789C314.11 449.98 310.782 451.793 310.053 454.84C309.325 457.886 311.472 461.012 314.849 461.821C318.226 462.63 321.554 460.817 322.282 457.77Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.999 436.498C294.462 425.363 283.38 414.72 268.246 412.728C253.113 410.735 239.659 418.147 238.196 429.283C236.733 440.418 247.815 451.061 262.948 453.053C278.082 455.046 291.536 447.634 292.999 436.498Z",
    fill: "#454C5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.961 434.082C270.891 435.327 269.786 436.226 268.611 436.088C267.368 436.019 266.47 434.912 266.608 433.736",
    stroke: "#4BD1CE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.122 433.704C258.247 429.735 257.166 425.951 254.707 425.252C252.247 424.553 249.341 427.204 248.216 431.173C247.09 435.142 248.171 438.926 250.631 439.625C253.09 440.324 255.996 437.673 257.122 433.704Z",
    stroke: "#4BD1CE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.761 441.03C287.283 440.608 288.776 436.967 288.096 432.898C287.417 428.829 284.822 425.872 282.3 426.294C279.779 426.716 278.285 430.357 278.965 434.426C279.644 438.496 282.239 441.452 284.761 441.03Z",
    stroke: "#4BD1CE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.203 419.349C253.203 419.349 256.312 416.582 258.8 419.349",
    stroke: "#4BD1CE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.625 420.179C276.625 420.179 278.974 417.412 282.221 420.179",
    stroke: "#4BD1CE",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M322.422 457.753C334.34 456.191 342.736 445.253 341.176 433.322C339.616 421.391 328.69 412.985 316.772 414.547C304.854 416.109 296.458 427.047 298.018 438.978C299.578 450.909 310.504 459.314 322.422 457.753Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.524 450.895C329.658 449.829 335.389 442.363 334.324 434.22C333.259 426.077 325.802 420.34 317.668 421.406C309.534 422.472 303.803 429.937 304.868 438.081C305.932 446.224 313.39 451.961 321.524 450.895Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.905 446.162C326.429 445.438 330.321 440.368 329.598 434.838C328.875 429.309 323.81 425.413 318.287 426.136C312.763 426.86 308.871 431.93 309.594 437.46C310.318 442.99 315.382 446.886 320.905 446.162Z",
    fill: "#F6C84A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M329.62 434.84C328.929 429.307 323.816 425.433 318.358 426.125C317.529 426.263 316.7 426.471 315.94 426.747C317.874 428.338 319.187 430.621 319.533 433.249C320.154 437.883 317.46 442.241 313.314 443.901C315.387 445.561 318.151 446.46 320.984 446.114C326.442 445.423 330.311 440.304 329.62 434.84Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.103 511.134C235.103 511.134 235.586 502.488 238.074 500.758C240.561 499.098 245.052 500.482 245.052 500.482C245.052 500.482 242.495 497.369 236.968 497.369C231.372 497.369 228.401 504.217 227.434 509.819L235.103 511.134Z",
    fill: "#BBDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.052 500.481C244.292 499.928 243.187 499.651 242.082 499.582C241.805 499.72 241.529 499.859 241.252 499.928C240.354 500.205 239.525 500.62 238.627 500.896C239.871 501.865 241.46 503.594 241.46 506.153C241.46 510.372 239.042 514.107 239.042 514.107L242.565 521.508C242.565 521.508 247.402 512.24 247.954 507.882C248.507 503.525 245.052 500.481 245.052 500.481Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.452 511.203C237.452 511.203 224.878 505.462 216.311 514.593",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.896 510.372C234.896 510.372 227.987 508.782 224.256 510.165L226.26 515.214L233.86 515.56L234.896 510.372Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.436 509.819C227.436 509.819 227.988 499.651 234.552 497.715C240.494 495.916 248.301 500.135 247.956 507.882C247.748 512.724 244.156 516.528 243.327 519.987",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.52 511.202C235.52 511.202 234.691 496.331 245.054 500.481",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.283 501.104C238.283 501.104 241.392 502.141 241.461 505.461C241.531 509.611 239.734 512.724 239.734 512.724",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.346 507.537C255.346 507.537 258.939 510.303 258.731 514.661C258.524 519.019 254.24 528.633 254.24 528.633L250.233 521.509C250.233 521.509 252.375 517.635 252.099 513.416C251.822 509.197 247.4 507.537 247.4 507.537C247.4 507.537 252.789 505.877 255.346 507.537Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.364 516.112C246.364 516.112 246.018 510.094 248.436 508.296C250.786 506.428 255.415 507.535 255.415 507.535C255.415 507.535 252.72 504.63 247.124 504.976C241.596 505.322 239.385 509.541 238.764 515.213L246.364 516.112Z",
    fill: "#BBDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.695 514.66C238.695 514.66 238.903 507.536 244.706 505.392C250.579 503.248 258.594 506.914 258.732 514.66C258.87 519.502 255.554 523.583 254.932 527.042",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.434 516.804C246.434 516.804 244.707 504.008 255.347 507.466",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.438 508.297C248.438 508.297 251.823 509.473 252.099 512.724C252.445 516.874 250.856 520.055 250.856 520.055",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.794 524.137L235.932 526.419L233.307 526.004L235.794 524.137Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.743 527.25C245.743 527.25 246.088 532.092 245.259 532.438C244.292 532.922 241.252 528.495 241.252 528.495L245.743 527.25Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.764 510.164C238.764 510.164 249.611 512.101 253.757 518.948C257.902 525.796 254.586 536.586 254.586 536.586L251.408 553.948C251.408 553.948 251.201 555.677 248.921 555.677C246.571 555.677 239.801 554.224 239.801 554.224L244.775 532.644L246.641 522.13L237.244 516.458L238.764 510.164Z",
    fill: "#BBDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.973 510.164L242.289 510.787C251.34 512.516 257.282 521.3 255.624 530.361L251.34 553.948C251.133 555.123 250.027 555.884 248.853 555.677L238.766 553.948",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.535 526.42C245.811 529.048 244.844 533.613 244.844 533.613",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.012 508.756L211.531 514.668L217.659 528.67L231.139 522.758L225.012 508.756Z",
    fill: "#FADE92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.016 508.781L226.881 513.277L213.547 519.156L211.543 514.661L225.016 508.781Z",
    fill: "#FF7468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.012 508.756L211.531 514.668L217.659 528.67L231.139 522.758L225.012 508.756Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.545 519.157L226.88 513.277",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.204 515.146C214.927 515.284 214.513 515.146 214.374 514.8L213.338 512.379C213.2 512.102 213.338 511.687 213.684 511.549C213.96 511.411 214.374 511.549 214.513 511.895L215.549 514.316C215.687 514.662 215.549 515.008 215.204 515.146Z",
    fill: "#5E6574",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.002 513.486C218.726 513.624 218.311 513.486 218.173 513.14L217.137 510.719C216.999 510.442 217.137 510.027 217.482 509.889C217.759 509.751 218.173 509.889 218.312 510.235L219.348 512.656C219.486 513.002 219.348 513.347 219.002 513.486Z",
    fill: "#5E6574",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.874 511.826C222.597 511.964 222.183 511.826 222.044 511.48L221.008 509.059C220.87 508.782 221.008 508.367 221.353 508.229C221.63 508.09 222.044 508.229 222.183 508.575L223.219 510.996C223.288 511.272 223.15 511.687 222.874 511.826Z",
    fill: "#5E6574",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.756 508.574L235.589 520.54L235.52 512.102L232.756 508.574Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.708 509.265L239.457 506.775L236.279 506.845L238.283 509.335L243.465 511.825H246.712L244.708 509.265Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.956 515.49L236.279 521.024L243.05 515.698L247.956 515.49Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.713 511.824L247.956 515.49L243.051 515.698L243.465 511.824H246.713Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.05 515.697L235.52 512.101L238.283 509.334L243.465 511.824L243.05 515.697Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.283 509.334L236.279 506.844L232.617 508.158L235.519 512.101L238.283 509.334Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.52 512.102L235.727 521.37L243.05 515.698L235.52 512.102Z",
    fill: "#66D4BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.708 509.265L239.457 506.775L236.279 506.845L238.283 509.335L243.465 511.825H246.712L244.708 509.265Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.05 515.698L235.727 521.37L235.52 512.102",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.05 515.697L235.52 512.101L238.283 509.334L243.465 511.824L243.05 515.697Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.713 511.824L247.956 515.49L243.051 515.698",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.279 506.775L232.617 508.159L235.519 512.101",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.956 515.49L235.727 521.37",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.617 508.158L235.726 521.369",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.863 516.39C237.383 520.678 235.172 525.382 230.888 526.973C226.605 528.494 221.907 526.281 220.317 521.993C218.797 517.704 221.008 513.001 225.292 511.41C229.576 509.819 234.274 512.102 235.863 516.39Z",
    fill: "#FFCC4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.863 516.39C237.383 520.678 235.172 525.382 230.888 526.973C226.605 528.494 221.907 526.281 220.317 521.993C218.797 517.704 221.008 513.001 225.292 511.41C229.576 509.819 234.274 512.102 235.863 516.39Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.026 515.905C231.234 516.528 230.957 517.15 230.335 517.358C229.714 517.565 229.092 517.289 228.884 516.666C228.677 516.044 228.954 515.421 229.575 515.214C230.197 514.937 230.819 515.283 231.026 515.905Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.845 517.772C226.052 518.395 225.776 519.018 225.154 519.225C224.532 519.433 223.91 519.156 223.703 518.533C223.496 517.911 223.772 517.288 224.394 517.081C225.016 516.804 225.637 517.15 225.845 517.772Z",
    fill: "#5E6574"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.856 520.402C231.58 521.578 230.681 522.616 229.438 523.1C228.194 523.515 226.881 523.307 225.914 522.616",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.041 520.471C238.073 519.571 236.761 519.087 235.448 519.295C233.168 519.641 231.579 521.854 231.924 524.137C232.546 527.941 238.35 531.883 240.768 531.538C243.255 531.123 247.539 525.589 246.917 521.785C246.571 519.433 244.361 517.842 242.081 518.257C240.768 518.465 239.662 519.295 239.041 520.471Z",
    fill: "#FF7468"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.041 520.471C238.073 519.571 236.761 519.087 235.448 519.295C233.168 519.641 231.579 521.854 231.924 524.137C232.546 527.941 238.35 531.883 240.768 531.538C243.255 531.123 247.539 525.589 246.917 521.785C246.571 519.433 244.361 517.842 242.081 518.257C240.768 518.465 239.662 519.295 239.041 520.471Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.186 531.053C243.186 531.053 245.328 531.053 244.292 536.656C243.186 542.604 241.597 552.011 241.597 552.011C241.597 552.011 242.219 554.57 237.037 553.671C231.856 552.772 211.059 549.106 211.059 549.106C211.059 549.106 208.641 548.829 209.124 546.27C209.608 543.711 214.03 521.162 214.03 521.162L243.186 531.053Z",
    fill: "#78BCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.186 531.054C245.466 531.746 244.706 535.412 244.706 535.412L241.666 552.012C241.458 553.326 240.146 554.225 238.833 553.949L211.127 549.038C209.814 548.83 208.916 547.516 209.193 546.202L214.098 521.094",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.723 539.699L236.068 543.503",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.164 541.998C217.418 540.841 217.231 539.817 216.747 539.71C216.262 539.604 215.664 540.455 215.409 541.611C215.155 542.768 215.342 543.792 215.826 543.898C216.311 544.005 216.91 543.154 217.164 541.998Z",
    fill: "#5E6574",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.186 531.053C240.491 530.223 238.211 536.932 233.236 538.593C228.262 540.253 221.975 539.146 217.898 533.267C213.822 527.387 214.029 521.162 214.029 521.162L243.186 531.053Z",
    fill: "#BBDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.029 521.162L243.186 531.053",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.029 521.162C214.029 521.162 213.753 527.318 217.898 533.267C222.044 539.215 228.262 540.253 233.237 538.593C238.211 536.932 240.491 530.223 243.186 531.053",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.252 497.369C241.252 497.369 216.034 495.778 218.037 482.913C219.419 474.336 232.615 472.814 232.615 472.814",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.594 503.663C242.703 503.663 245.259 501.242 245.328 498.198C245.397 495.155 242.841 492.665 239.732 492.596C236.623 492.596 234.067 495.017 233.997 498.06C233.928 501.103 236.485 503.593 239.594 503.663Z",
    fill: "#4BD1CE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.456 503.525C242.565 503.594 245.19 501.242 245.328 498.199C245.467 495.155 243.048 492.596 239.87 492.527C236.692 492.458 234.136 494.809 233.998 497.853C233.928 500.896 236.347 503.455 239.456 503.525Z",
    stroke: "#5E6574",
    strokeWidth: 1.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.35 641.07C1424.35 641.07 1427.5 585.563 1376.54 549.943C1376.54 549.943 1407.85 602.08 1403.03 635.789",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1424.58 639.498C1424.58 639.498 1427.5 585.564 1376.54 549.832C1376.54 549.832 1407.85 601.969 1403.03 635.678",
    stroke: "#5E6574",
    strokeWidth: 1.13506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.73 642.308C1439.73 642.308 1435.58 547.585 1417.06 518.033C1417.06 518.033 1416.94 579.496 1423.57 641.072",
    fill: "#00B894"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1439.73 642.308C1439.73 642.308 1436.25 554.103 1416.5 515C1416.5 515 1417.17 577.924 1423.9 639.387",
    stroke: "#5E6574",
    strokeWidth: 1.13506,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1167_13770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 575,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaiserSignupBackgroundGraphic);
export default __webpack_public_path__ + "static/media/KaiserSignupBackgroundGraphic.6eb8e9e3176fc0d363a7eb20c1d60eda.svg";
export { ForwardRef as ReactComponent };